// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3RRZC","header":"MessagesList_header__1y5nr","chat":"MessagesList_chat__1hIIS"};